<div class="route madar--v2 flex align-flex-start">
  <mat-card class="route__card stop card--bordered">
    <header class="stop__head flex align-flex-start justify-space-between py-3 px-6">
      <div class="stop__heading">
        <span class="stop__kind small text-default">{{ 'shipments.ShippingCard.Pickup' | translate }}</span>
        <h4 class="stop__city m-0" [title]="shipment.pickUpLocation?.city?.name">{{ shipment.pickUpLocation?.city?.name || 'ــ' }}</h4>
        <p class="stop__place m-0 small weight-normal text-default" [title]="pickUpPlace">{{ pickUpPlace }}</p>
      </div>

      <span class="stop__date flex column align-center bg-white brd brd-200" *ngIf="shipment.pickUpDate">
        <span class="stop__date-month w-100 text-center text-white bg-accent">{{ shipment.pickUpDate | date: 'MMM' }}</span>
        <span class="stop__date-day w-100 text-center text-900 weight-medium bg-white h6 m-0">{{ shipment.pickUpDate | date: 'd' }}</span>
      </span>
    </header>

    <div class="stop__contact brd-t brd-200">
      <app-expandable-panel
        class="stop__panel d-block"
        [inline]="false"
        [expanded]="false"
      >
        <div toggle class="stop__toggle flex align-center text-nowrap w-100 my-3 small weight-normal text-default">
          <app-icon class="stop__toggle-icon mr-1 text-default" name="outline-user" size="xs"></app-icon>
          <span class="stop__toggle-label text-nowrap">{{ 'shipments.ShippingCard.ContactPerson' | translate }}</span>
          <span class="stop__toggle-dot mx-2 text-default" aria-hidden="true">&bull;</span>
          <ng-container *ngIf="pickUpContact; else noPickUpContact">
            <span class="stop__toggle-name text-ellipsis text-nowrap text-default" [title]="pickUpContact.firstName + ' ' + pickUpContact.lastName">
              {{ pickUpContact.firstName }} {{ pickUpContact.lastName }}
            </span>
          </ng-container>
          <ng-template #noPickUpContact>
            <span class="stop__toggle-name text-ellipsis text-nowrap text-300">{{ 'shipments.ShippingCard.NoContact' | translate }}</span>
          </ng-template>
        </div>

        <dl class="stop__facts m-0 px-6 pb-3 pt-0">
          <div class="fact flex align-center justify-space-between pb-3 px-0">
            <div class="fact__key flex align-center">
              <app-icon class="stop__toggle-icon mr-1 text-default" name="outline-call" size="xs"></app-icon>
              <span class="fact__label small weight-normal text-default">{{ 'shipments.ShippingCard.Phone' | translate }}</span>
            </div>
            <span class="fact__value text-ellipsis text-nowrap m-0 text-right small weight-normal" *ngIf="pickUpContact?.mobileNumber; else noPickUpPhone" dir="ltr">
              {{ pickUpContact.mobileNumber }}
            </span>
            <ng-template #noPickUpPhone>
              <span class="fact__value text-ellipsis text-nowrap m-0 text-right weight-normal text-300 small">{{ 'shipments.ShippingCard.NotMentioned' | translate }}</span>
            </ng-template>
          </div>

          <div class="fact flex align-center justify-space-between pb-3 px-0">
            <div class="fact__key flex align-center">
              <app-icon class="stop__toggle-icon mr-1 text-default" name="outline-calendar" size="xs"></app-icon>
              <span class="fact__label small weight-normal text-default">{{ 'shipments.ShippingCard.PickupTime' | translate }}</span>
            </div>
            <span class="fact__value text-ellipsis text-nowrap m-0 text-right small weight-normal" *ngIf="shipment.pickUpDate; else noPickUpTime">
              {{ shipment.pickUpDate | date: 'd MMM yyyy, hh:mm a' }}
            </span>
            <ng-template #noPickUpTime>
              <span class="fact__value text-ellipsis text-nowrap m-0 text-right weight-normal text-300 small">{{ 'shipments.ShippingCard.NotMentioned' | translate }}</span>
            </ng-template>
          </div>

          <div class="fact flex align-center justify-space-between pb-3 px-0">
            <div class="fact__key flex align-center">
              <app-icon class="stop__toggle-icon mr-1 text-default" name="outline-calendar" size="xs"></app-icon>
              <span class="fact__label small weight-normal text-default">{{ 'shipments.ShippingCard.CompletedOn' | translate }}</span>
            </div>
            <span class="fact__value text-ellipsis text-nowrap m-0 text-right small weight-normal" *ngIf="pickUpCompletedOn; else noPickUpCompletion">
              {{ pickUpCompletedOn | date: 'd MMM yyyy, hh:mm a' }}
            </span>
            <ng-template #noPickUpCompletion>
              <span class="fact__value text-ellipsis text-nowrap m-0 text-right weight-normal text-300 small">{{ 'shipments.ShippingCard.NotCompletedYet' | translate }}</span>
            </ng-template>
          </div>
        </dl>
      </app-expandable-panel>
    </div>
  </mat-card>

  <span
    class="route__arrow text-default"
    aria-hidden="true"
  >
    <app-icon name="outline-arrow-right" size="xs"></app-icon>
  </span>

  <!-- Dropoff -->
  <mat-card class="route__card stop card--bordered">
    <header class="stop__head flex align-flex-start justify-space-between py-3 px-6">
      <div class="stop__heading">
        <span class="stop__kind small text-default">{{ 'shipments.ShippingCard.Dropoff' | translate }}</span>
        <h4 class="stop__city m-0" [title]="shipment.dropOffLocation?.city?.name">{{ shipment.dropOffLocation?.city?.name || 'ــ' }}</h4>

        <p class="stop__place m-0 small weight-normal text-default" [title]="dropOffPlace">{{ dropOffPlace }}</p>
      </div>

      <span class="stop__date flex column align-center bg-white brd brd-200" *ngIf="shipment.deliveryDate">
        <span class="stop__date-month w-100 text-center text-white bg-accent">{{ shipment.deliveryDate | date: 'MMM' }}</span>

        <span class="stop__date-day w-100 text-center text-900 weight-medium bg-white h6 m-0">{{ shipment.deliveryDate | date: 'd' }}</span>
      </span>
    </header>

    <div class="stop__contact brd-t brd-200">
      <app-expandable-panel
        class="stop__panel d-block"
        [inline]="false"
        [expanded]="false"
      >
        <div toggle class="stop__toggle flex align-center text-nowrap w-100 my-3 small weight-normal text-default">
          <app-icon class="stop__toggle-icon mr-1 text-default" name="outline-user" size="xs"></app-icon>
          <span class="stop__toggle-label text-nowrap">{{ 'shipments.ShippingCard.ContactPerson' | translate }}</span>
          <span class="stop__toggle-dot mx-2 text-default" aria-hidden="true">&bull;</span>
          <ng-container *ngIf="dropOffContact; else noDropOffContact">
            <span class="stop__toggle-name text-ellipsis text-nowrap text-default" [title]="dropOffContact.firstName + ' ' + dropOffContact.lastName">
              {{ dropOffContact.firstName }} {{ dropOffContact.lastName }}
            </span>
          </ng-container>
          <ng-template #noDropOffContact>
            <span class="stop__toggle-name text-ellipsis text-nowrap text-300">{{ 'shipments.ShippingCard.NoContact' | translate }}</span>
          </ng-template>
        </div>

        <dl class="stop__facts m-0 px-6 pb-3 pt-0">
          <div class="fact flex align-center justify-space-between pb-3 px-0">
             <div class="fact__key flex align-center">
              <app-icon class="stop__toggle-icon mr-1 text-default" name="outline-call" size="xs"></app-icon>
              <span class="fact__label small weight-normal text-default">{{ 'shipments.ShippingCard.Phone' | translate }}</span>
            </div>
            <span class="fact__value text-ellipsis text-nowrap m-0 text-right small weight-normal" *ngIf="dropOffContact?.mobileNumber; else noDropOffPhone" dir="ltr">
              {{ dropOffContact.mobileNumber }}
            </span>
            <ng-template #noDropOffPhone>
              <span class="fact__value text-ellipsis text-nowrap m-0 text-right weight-normal text-300 small">{{ 'shipments.ShippingCard.NotMentioned' | translate }}</span>
            </ng-template>
          </div>

          <div class="fact flex align-center justify-space-between pb-3 px-0">
            <div class="fact__key flex align-center">
              <app-icon class="stop__toggle-icon mr-1 text-default" name="outline-calendar" size="xs"></app-icon>
              <span class="fact__label small weight-normal text-default">{{ 'shipments.ShippingCard.DropoffTime' | translate }}</span>
            </div>
            <span class="fact__value text-ellipsis text-nowrap m-0 text-right small weight-normal" *ngIf="shipment.deliveryDate; else noDropOffTime">
              {{ shipment.deliveryDate | date: 'd MMM yyyy, hh:mm a' }}
            </span>
            <ng-template #noDropOffTime>
              <span class="fact__value text-ellipsis text-nowrap m-0 text-right weight-normal text-300 small">{{ 'shipments.ShippingCard.NotMentioned' | translate }}</span>
            </ng-template>
          </div>

          <div class="fact flex align-center justify-space-between pb-3 px-0">
            <div class="fact__key flex align-center">
              <app-icon class="stop__toggle-icon mr-1 text-default" name="outline-calendar" size="xs"></app-icon>
              <span class="fact__label small weight-normal text-default">{{ 'shipments.ShippingCard.CompletedOn' | translate }}</span>
            </div>
            <span class="fact__value text-ellipsis text-nowrap m-0 text-right small weight-normal" *ngIf="dropOffCompletedOn; else noDropOffCompletion">
              {{ dropOffCompletedOn | date: 'd MMM yyyy, hh:mm a' }}
            </span>
            <ng-template #noDropOffCompletion>
              <span class="fact__value text-ellipsis text-nowrap m-0 text-right weight-normal text-300 small">{{ 'shipments.ShippingCard.NotCompletedYet' | translate }}</span>
            </ng-template>
          </div>

          <!-- Kept from the previous card, which showed the OTP beside the dropoff contact. -->
          <div class="fact flex align-center justify-space-between pb-3 px-0" *ngIf="shipment?.otp">
            <dt class="fact__label small weight-normal text-default">{{ 'shipments.ShippingCard.OTP' | translate }}</dt>
            <span class="fact__value text-ellipsis text-nowrap m-0 text-right small weight-normal">{{ shipment.otp }}</span>
          </div>
        </dl>
      </app-expandable-panel>
    </div>
  </mat-card>
</div>
